import React from "react"
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import { BRANDS, MODES, TYPES } from "../../configs";

const MobilePlaceHolder = loadable(() => import("./MobilePlaceHolder"));
const InsidePagePlaceHolder = loadable(() => import("./InsidePagePlaceholder"));
const HomePagePlaceholder = loadable(() => import("./HomePagePlaceholder"));

const TABFIELDLENGTH = {
    PACKAGES: 5,
    HOTELS: 4,
    CRUISES: 6,
    FLIGHTS: 6,
}

const Placeholder = ({config}) => {
    
    if(config?.brand !== BRANDS.SOV) {
        return <></>;
    }

    let length = TABFIELDLENGTH.PACKAGES;
    const isFlightOrCruiseTab = config?.type === TYPES.FLIGHTS.toLowerCase() || config?.type === TYPES.CRUISES.toLowerCase();

    if(config?.type === TYPES.FLIGHTS.toLowerCase()) { 
        length = TABFIELDLENGTH.FLIGHTS;
    } else if (config?.type === TYPES.HOTELS.toLowerCase()) {
        length = TABFIELDLENGTH.HOTELS;
    } else if (config?.type === TYPES.CRUISES.toLowerCase()) {
        length = TABFIELDLENGTH.CRUISES;
    }

    if (config?.sovSimplifiedSearchBar && (!config?.sovTablet || !config?.sovDesktop)) {
        return <MobilePlaceHolder brand={config?.brand} />;
    }

    if (config?.mode !== MODES.TABS && !config?.sovSimplifiedSearchBar && (config?.sovTablet || config?.sovDesktop)) {
        return <InsidePagePlaceHolder brand={config.brand} type={config?.type} isFlightOrCruiseTab={isFlightOrCruiseTab} length={length} />;
    }

    if (config?.mode === MODES.TABS && !config?.sovSimplifiedSearchBar) {
        return <HomePagePlaceholder brand={config.brand} mode={config?.mode} type={config?.type} isFlightOrCruiseTab={isFlightOrCruiseTab} length={length} />
    }

    return <></>
}


Placeholder.propTypes = {
	config: PropTypes.shape({
        sovDesktop: PropTypes.bool,
		sovSimplifiedSearchBar: PropTypes.bool,
		sovTablet: PropTypes.bool,
		type: PropTypes.string,
		mode: PropTypes.string,
		brand: PropTypes.string
    }).isRequired,
};

export { Placeholder }
export default Placeholder